export class NotificationModel {
    public constructor(
        public type: "success" | "warning" | "error",
        public title: string,
        public text: string
    ) {
    }
}
